// @flow
import * as React from "react";
import Media from "react-media";

type Props = {
  children: React.Node
};

function Desktop({ children }: Props) {
  return (
    <Media query="(min-width: 960px)">
      {matches => (matches ? children : null)}
    </Media>
  );
}

function Mobile({ children }: Props) {
  return (
    <Media query="(max-width: 959px)">
      {matches => (matches ? children : null)}
    </Media>
  );
}

export { Desktop, Mobile };



// WEBPACK FOOTER //
// ./src/components/layout/Layout.js